// DEVNOTE: Greeting card add-on logic (2 variants + none) | file:assets/dev-card-addon.js | updated:2026-02-28
(() => {
  if (window.__devCardAddonInit) return;
  window.__devCardAddonInit = true;

  const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const STORAGE_KEY_PREFIX = "dev:card-addon:v1";
  const variantMetaCache = {};
  let storageAvailable = null;

  function getInt(value, fallback) {
    const n = parseInt(value, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function canUseStorage() {
    if (storageAvailable !== null) return storageAvailable;
    try {
      const key = `${STORAGE_KEY_PREFIX}:test`;
      window.localStorage.setItem(key, "1");
      window.localStorage.removeItem(key);
      storageAvailable = true;
    } catch (_error) {
      storageAvailable = false;
    }
    return storageAvailable;
  }

  function formatMoney(cents) {
    const normalizedCents = getInt(cents, 0);
    const currencyCode =
      (window.Shopify &&
        window.Shopify.currency &&
        (window.Shopify.currency.active || window.Shopify.currency.current)) ||
      "";

    if (currencyCode && typeof Intl !== "undefined" && typeof Intl.NumberFormat === "function") {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: "currency",
          currency: currencyCode,
          currencyDisplay: "symbol",
        }).format(normalizedCents / 100);
      } catch (_error) {
        // Continue with Shopify format fallback.
      }
    }

    const format =
      (window.themeHDN &&
        window.themeHDN.settings &&
        (window.themeHDN.settings.moneyWithCurrencyFormat || window.themeHDN.settings.moneyFormat)) ||
      (window.Shopify && (window.Shopify.money_with_currency_format || window.Shopify.money_format)) ||
      "${{amount}}";

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(normalizedCents, format);
    }
    return (normalizedCents / 100).toFixed(2);
  }

  function setError(addonEl, message) {
    const box = addonEl.querySelector(".dev-card-addon__error");
    if (!box) return;
    box.textContent = message || "";
    box.hidden = !message;
  }

  function getSelectedCardVariantId(addonEl) {
    const checked = addonEl.querySelector('input[data-dev-card-choice]:checked');
    const val = checked ? checked.value : "";
    return getInt(val, 0); // 0 => "без картичка"
  }

  function getCheckedChoiceInput(addonEl) {
    return addonEl.querySelector('input[data-dev-card-choice]:checked');
  }

  function getChoiceLabel(choiceInput) {
    if (!choiceInput) return "";
    if (choiceInput.dataset.devCardLabel) return choiceInput.dataset.devCardLabel;

    const optionLabel = choiceInput.closest(".dev-card-addon__option");
    const textNode = optionLabel ? optionLabel.querySelector(".dev-card-addon__option-text") : null;
    return textNode ? (textNode.textContent || "").trim() : "";
  }

  function getChoicePriceNode(choiceInput) {
    const optionLabel = choiceInput ? choiceInput.closest(".dev-card-addon__option") : null;
    return optionLabel ? optionLabel.querySelector("[data-dev-card-option-price]") : null;
  }

  function getChoiceImageNode(choiceInput) {
    const optionLabel = choiceInput ? choiceInput.closest(".dev-card-addon__option") : null;
    return optionLabel ? optionLabel.querySelector("[data-dev-card-option-image]") : null;
  }

  function getChoicePlaceholderNode(choiceInput) {
    const optionLabel = choiceInput ? choiceInput.closest(".dev-card-addon__option") : null;
    return optionLabel ? optionLabel.querySelector("[data-dev-card-option-placeholder]") : null;
  }

  function setChoicePriceCents(choiceInput, cents) {
    if (!choiceInput) return;
    const normalized = getInt(cents, NaN);
    if (!Number.isFinite(normalized)) return;
    choiceInput.dataset.devCardPriceCents = String(normalized);

    const node = getChoicePriceNode(choiceInput);
    if (!node) return;
    if (normalized > 0) {
      node.textContent = `(+ ${formatMoney(normalized)})`;
    } else {
      node.textContent = "";
    }
  }

  function getChoicePriceCents(choiceInput) {
    const stored = choiceInput ? choiceInput.dataset.devCardPriceCents : "";
    const parsed = getInt(stored, NaN);
    return Number.isFinite(parsed) ? parsed : NaN;
  }

  function normalizeImageUrl(url) {
    if (!url || typeof url !== "string") return "";
    if (url.startsWith("//")) return `https:${url}`;
    return url;
  }

  function setChoiceImageMeta(choiceInput, imageUrl, imageAlt) {
    if (!choiceInput) return;
    const normalizedUrl = normalizeImageUrl(imageUrl);
    const normalizedAlt = imageAlt || getChoiceLabel(choiceInput) || "";
    choiceInput.dataset.devCardImageUrl = normalizedUrl;
    choiceInput.dataset.devCardImageAlt = normalizedAlt;

    const imageNode = getChoiceImageNode(choiceInput);
    const placeholderNode = getChoicePlaceholderNode(choiceInput);
    if (imageNode && normalizedUrl) {
      imageNode.src = normalizedUrl;
      imageNode.alt = normalizedAlt;
      imageNode.hidden = false;
      if (placeholderNode) placeholderNode.hidden = true;
    } else if (imageNode) {
      imageNode.removeAttribute("src");
      imageNode.alt = normalizedAlt;
      imageNode.hidden = true;
      if (placeholderNode) placeholderNode.hidden = false;
    }
  }

  function getChoiceImageMeta(choiceInput) {
    if (!choiceInput) return { imageUrl: "", imageAlt: "" };
    return {
      imageUrl: choiceInput.dataset.devCardImageUrl || "",
      imageAlt: choiceInput.dataset.devCardImageAlt || getChoiceLabel(choiceInput) || "",
    };
  }

  function getAddonStorageKey(addonEl) {
    const parentHandle = (addonEl && addonEl.dataset && addonEl.dataset.parentHandle) || "";
    if (!parentHandle) return "";
    return `${STORAGE_KEY_PREFIX}:${parentHandle}`;
  }

  function persistAddonState(addonEl) {
    if (!addonEl || !canUseStorage()) return;
    const key = getAddonStorageKey(addonEl);
    if (!key) return;

    const checked = getCheckedChoiceInput(addonEl);
    const variantId = checked ? String(checked.value || "") : "";
    const textarea = addonEl.querySelector(".dev-card-addon__textarea");
    const message = textarea ? String(textarea.value || "") : "";

    try {
      if (!variantId && !message.trim()) {
        window.localStorage.removeItem(key);
        return;
      }
      window.localStorage.setItem(
        key,
        JSON.stringify({
          variantId,
          message,
        })
      );
    } catch (_error) {
      // Ignore storage write errors.
    }
  }

  function restoreAddonState(addonEl) {
    if (!addonEl || !canUseStorage()) return;
    const key = getAddonStorageKey(addonEl);
    if (!key) return;

    let parsed = null;
    try {
      const raw = window.localStorage.getItem(key);
      if (!raw) return;
      parsed = JSON.parse(raw);
    } catch (_error) {
      return;
    }
    if (!parsed || typeof parsed !== "object") return;

    const wantedVariantId = String(parsed.variantId || "");
    if (wantedVariantId) {
      let foundChoice = null;
      addonEl.querySelectorAll('input[data-dev-card-choice]').forEach((input) => {
        if (!foundChoice && String(input.value || "") === wantedVariantId) {
          foundChoice = input;
        }
      });
      if (foundChoice) {
        foundChoice.checked = true;
      }
    }

    const textarea = addonEl.querySelector(".dev-card-addon__textarea");
    if (textarea && typeof parsed.message === "string") {
      textarea.value = parsed.message;
    }
  }

  async function fetchVariantMeta(variantId) {
    const id = getInt(variantId, 0);
    if (!id) {
      return { priceCents: 0, imageUrl: "", imageAlt: "" };
    }
    if (Object.prototype.hasOwnProperty.call(variantMetaCache, id)) {
      return variantMetaCache[id];
    }

    try {
      const res = await fetch(`${rootPath}variants/${id}.js`, {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      if (!res.ok) {
        variantMetaCache[id] = { priceCents: 0, imageUrl: "", imageAlt: "" };
        return variantMetaCache[id];
      }
      const data = await res.json();
      const cents = getInt(data && data.price, 0);
      const rawImage =
        (data && data.featured_image && (data.featured_image.src || data.featured_image.url)) ||
        (data && data.image && (data.image.src || data.image.url)) ||
        "";
      const imageUrl = normalizeImageUrl(rawImage);
      const imageAlt =
        (data && data.featured_image && data.featured_image.alt) ||
        (data && data.image && data.image.alt) ||
        (data && data.public_title) ||
        (data && data.title) ||
        "";

      variantMetaCache[id] = { priceCents: cents, imageUrl, imageAlt };
      return variantMetaCache[id];
    } catch (_error) {
      variantMetaCache[id] = { priceCents: 0, imageUrl: "", imageAlt: "" };
      return variantMetaCache[id];
    }
  }

  function initAddon(addonEl) {
    if (addonEl.dataset.devInit === "1") return;
    addonEl.dataset.devInit = "1";

    const messageWrap = addonEl.querySelector(".dev-card-addon__message");
    const selectionEl = addonEl.querySelector("[data-dev-card-selection]");
    const selectedCardEl = addonEl.querySelector("[data-dev-card-selected-card]");
    const selectedImageEl = addonEl.querySelector("[data-dev-card-selected-image]");
    const selectedPlaceholderEl = addonEl.querySelector("[data-dev-card-selected-placeholder]");
    const selectedTitleEl = addonEl.querySelector("[data-dev-card-selected-title]");
    const selectedPriceEl = addonEl.querySelector("[data-dev-card-selected-price]");
    const textarea = addonEl.querySelector(".dev-card-addon__textarea");
    const countEl = addonEl.querySelector("[data-dev-card-count]");
    const maxChars = getInt(addonEl.dataset.maxChars, 150);

    restoreAddonState(addonEl);

    const updateCount = () => {
      if (!textarea || !countEl) return;
      const len = (textarea.value || "").length;
      countEl.textContent = String(Math.min(len, maxChars));
    };

    const ensureChoiceMeta = async (choiceInput) => {
      if (!choiceInput) return { priceCents: 0, imageUrl: "", imageAlt: "" };
      const variantId = getInt(choiceInput.value, 0);
      if (!variantId) {
        setChoicePriceCents(choiceInput, 0);
        setChoiceImageMeta(choiceInput, "", getChoiceLabel(choiceInput));
        return { priceCents: 0, imageUrl: "", imageAlt: getChoiceLabel(choiceInput) };
      }

      const existingPrice = getChoicePriceCents(choiceInput);
      const existingImage = getChoiceImageMeta(choiceInput);
      const fetched = await fetchVariantMeta(variantId);
      const meta = {
        priceCents: Number.isFinite(existingPrice) ? existingPrice : getInt(fetched.priceCents, 0),
        imageUrl: existingImage.imageUrl || fetched.imageUrl || "",
        imageAlt: existingImage.imageAlt || fetched.imageAlt || getChoiceLabel(choiceInput),
      };
      setChoicePriceCents(choiceInput, meta.priceCents);
      setChoiceImageMeta(choiceInput, meta.imageUrl, meta.imageAlt);
      return meta;
    };

    const hydrateAllChoiceMeta = async () => {
      const choices = addonEl.querySelectorAll('input[data-dev-card-choice]');
      for (const choiceInput of choices) {
        await ensureChoiceMeta(choiceInput);
      }
    };

    const updateActiveOptionClasses = () => {
      addonEl.querySelectorAll(".dev-card-addon__option").forEach((optionEl) => {
        const input = optionEl.querySelector('input[data-dev-card-choice]');
        optionEl.classList.toggle("is-active", Boolean(input && input.checked));
      });
    };

    const syncUI = async () => {
      setError(addonEl, "");
      const checked = getCheckedChoiceInput(addonEl);
      const cardId = checked ? getInt(checked.value, 0) : 0;
      const label = getChoiceLabel(checked) || "Без картичка";
      const selectedMeta = await ensureChoiceMeta(checked);
      const priceCents = getInt(selectedMeta.priceCents, 0);
      const imageMeta = getChoiceImageMeta(checked);

      updateActiveOptionClasses();

      if (selectionEl) {
        selectionEl.textContent =
          cardId > 0 ? `Избрано: ${label} (+ ${formatMoney(priceCents)})` : `Избрано: ${label}`;
      }

      if (selectedCardEl && selectedTitleEl && selectedPriceEl) {
        if (cardId > 0) {
          selectedCardEl.hidden = false;
          selectedTitleEl.textContent = label;
          selectedPriceEl.textContent = formatMoney(priceCents);

          if (selectedImageEl && imageMeta.imageUrl) {
            selectedImageEl.src = imageMeta.imageUrl;
            selectedImageEl.alt = imageMeta.imageAlt || label;
            selectedImageEl.hidden = false;
            if (selectedPlaceholderEl) selectedPlaceholderEl.hidden = true;
          } else {
            if (selectedImageEl) {
              selectedImageEl.removeAttribute("src");
              selectedImageEl.hidden = true;
            }
            if (selectedPlaceholderEl) {
              selectedPlaceholderEl.hidden = false;
              selectedPlaceholderEl.textContent = label.slice(0, 1).toUpperCase();
            }
          }
        } else {
          selectedCardEl.hidden = true;
        }
      }

      if (messageWrap) messageWrap.hidden = cardId === 0;
      if (cardId !== 0 && textarea) textarea.focus();
      persistAddonState(addonEl);
      document.dispatchEvent(new CustomEvent("dev:card-addon:change"));
    };

    addonEl.querySelectorAll('input[data-dev-card-choice]').forEach((el) => {
      el.addEventListener("change", () => {
        void syncUI();
      });
    });

    if (textarea) {
      textarea.addEventListener("input", () => {
        updateCount();
        persistAddonState(addonEl);
      });
      updateCount();
    }

    void hydrateAllChoiceMeta();
    void syncUI();
  }

  function initAllAddons(scope = document) {
    if (!scope || typeof scope.querySelectorAll !== "function") return;
    scope.querySelectorAll(".dev-card-addon").forEach(initAddon);
    if (scope.matches && scope.matches(".dev-card-addon")) {
      initAddon(scope);
    }
  }

  function initCartCardRescue(root) {
    if (!root || root.dataset.cardRescueInit === "1") return;

    const panel = root.querySelector("[data-card-rescue-panel]");
    const toggleButton = root.querySelector("[data-card-rescue-toggle]");
    const addon = root.querySelector(".dev-card-addon");
    const submitButton = root.querySelector("[data-card-rescue-submit]");
    const statusEl = root.querySelector("[data-card-rescue-status]");
    const errorEl = root.querySelector("[data-card-rescue-error]");
    const textarea = root.querySelector(".dev-card-addon__textarea");
    const submitLabel = submitButton ? submitButton.querySelector("span") : null;
    const toggleLabel = toggleButton ? toggleButton.querySelector("span") : null;

    if (!panel || !toggleButton || !addon || !submitButton || !submitLabel || !toggleLabel) return;

    root.dataset.cardRescueInit = "1";
    initAddon(addon);

    const messagePropertyName = root.dataset.cardMessageProperty || "Послание за картичка";
    const toggleAddLabel = root.dataset.toggleAddLabel || "Добави картичка";
    const toggleEditLabel = root.dataset.toggleEditLabel || "Промени";
    const toggleCloseLabel = root.dataset.toggleCloseLabel || "Скрий";
    const addLabel = root.dataset.addLabel || "Добави картичка";
    const saveLabel = root.dataset.saveLabel || "Запази картичката";
    const replaceLabel = root.dataset.replaceLabel || "Смени картичката";
    const removeLabel = root.dataset.removeLabel || "Премахни картичката";
    const processingLabel = root.dataset.processingLabel || "Обработваме...";
    const successLabel = root.dataset.successLabel || "Картичката е обновена.";

    let busy = false;
    let panelOpen = false;

    const getExistingLineKey = () => root.dataset.existingLineKey || "";
    const getExistingVariantId = () => getInt(root.dataset.existingVariantId, 0);
    const getExistingQuantity = () => Math.max(1, getInt(root.dataset.existingQuantity, 1));

    const getSelectedVariantId = () => {
      const checked = addon.querySelector("input[data-dev-card-choice]:checked");
      return checked ? getInt(checked.value, 0) : 0;
    };

    const getCollapsedToggleLabel = () => (getExistingLineKey() ? toggleEditLabel : toggleAddLabel);

    const syncPanelState = (forceOpen) => {
      if (typeof forceOpen === "boolean") {
        panelOpen = forceOpen;
      }
      panel.hidden = !panelOpen;
      root.classList.toggle("is-expanded", panelOpen);
      toggleButton.setAttribute("aria-expanded", panelOpen ? "true" : "false");
      toggleLabel.textContent = panelOpen ? toggleCloseLabel : getCollapsedToggleLabel();
    };

    const setStatus = (message, isError, isSuccess) => {
      if (!statusEl) return;
      statusEl.hidden = !message;
      statusEl.textContent = message || "";
      statusEl.classList.toggle("is-error", Boolean(isError));
      statusEl.classList.toggle("is-success", Boolean(isSuccess));
    };

    const setError = (message) => {
      if (!errorEl) return;
      errorEl.hidden = !message;
      errorEl.textContent = message || "";
    };

    const buildProperties = () => {
      const properties = {};
      const message = textarea ? String(textarea.value || "").trim() : "";
      if (message) {
        properties[messagePropertyName] = message;
      }
      return properties;
    };

    const parseResponse = async (response, fallbackMessage) => {
      let data = null;
      try {
        data = await response.json();
      } catch (_error) {}
      if (!response.ok || (data && data.status)) {
        throw new Error((data && (data.description || data.message)) || fallbackMessage);
      }
      return data;
    };

    const addCard = async (variantId, quantity) => {
      const formData = new FormData();
      const properties = buildProperties();
      formData.append("id", String(variantId));
      formData.append("quantity", String(Math.max(1, quantity || 1)));
      Object.keys(properties).forEach((key) => {
        formData.append(`properties[${key}]`, properties[key]);
      });

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        body: formData,
      });

      return parseResponse(response, "Не успяхме да добавим картичката.");
    };

    const updateExistingCard = async () => {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
          id: getExistingLineKey(),
          quantity: getExistingQuantity(),
          properties: buildProperties(),
        }),
      });

      return parseResponse(response, "Не успяхме да обновим картичката.");
    };

    const removeExistingCard = async () => {
      const existingLineKey = getExistingLineKey();
      if (!existingLineKey) return null;

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
          id: existingLineKey,
          quantity: 0,
        }),
      });

      return parseResponse(response, "Не успяхме да премахнем картичката.");
    };

    const syncButtonState = () => {
      if (busy) return;

      const selectedVariantId = getSelectedVariantId();
      const existingLineKey = getExistingLineKey();
      const existingVariantId = getExistingVariantId();

      setStatus("", false, false);
      setError("");

      if (!existingLineKey && selectedVariantId === 0) {
        submitButton.classList.add("is-hidden");
        submitButton.disabled = true;
        submitLabel.textContent = addLabel;
        return;
      }

      submitButton.classList.remove("is-hidden");
      submitButton.disabled = false;

      if (existingLineKey && selectedVariantId === 0) {
        submitLabel.textContent = removeLabel;
        return;
      }

      if (existingLineKey && selectedVariantId === existingVariantId) {
        submitLabel.textContent = saveLabel;
        return;
      }

      submitLabel.textContent = existingLineKey ? replaceLabel : addLabel;
    };

    const reloadCart = () => {
      document.dispatchEvent(new CustomEvent("cart:reload", { bubbles: true }));
    };

    submitButton.addEventListener("click", async () => {
      if (busy) return;

      const selectedVariantId = getSelectedVariantId();
      const existingLineKey = getExistingLineKey();
      const existingVariantId = getExistingVariantId();
      const existingQuantity = getExistingQuantity();

      busy = true;
      submitButton.disabled = true;
      submitButton.classList.remove("is-hidden");
      submitLabel.textContent = processingLabel;
      setStatus(processingLabel, false, false);
      setError("");

      try {
        if (existingLineKey && selectedVariantId === 0) {
          await removeExistingCard();
        } else if (existingLineKey && selectedVariantId === existingVariantId) {
          await updateExistingCard();
        } else if (existingLineKey && selectedVariantId > 0) {
          await addCard(selectedVariantId, existingQuantity);
          await removeExistingCard();
        } else if (selectedVariantId > 0) {
          await addCard(selectedVariantId, 1);
        }

        setStatus(successLabel, false, true);
        reloadCart();
      } catch (error) {
        setStatus("", false, false);
        setError((error && error.message) || "Възникна грешка при обработката на картичката.");
      } finally {
        busy = false;
        syncButtonState();
      }
    });

    toggleButton.addEventListener("click", () => {
      if (busy) return;
      syncPanelState(!panelOpen);
    });

    addon.querySelectorAll("input[data-dev-card-choice]").forEach((input) => {
      input.addEventListener("change", () => {
        syncPanelState(true);
        syncButtonState();
      });
    });

    if (textarea) {
      textarea.addEventListener("input", () => {
        syncPanelState(true);
        setStatus("", false, false);
        setError("");
        syncButtonState();
      });
    }

    syncPanelState(false);
    syncButtonState();
  }

  function initAllCartCardRescue(scope = document) {
    if (!scope || typeof scope.querySelectorAll !== "function") return;
    scope.querySelectorAll('[id^="hdt-cart-card-rescue-"]').forEach(initCartCardRescue);
    if (scope.matches && scope.matches('[id^="hdt-cart-card-rescue-"]')) {
      initCartCardRescue(scope);
    }
  }

  function initDynamicUi(scope = document) {
    initAllAddons(scope);
    initAllCartCardRescue(scope);
  }

  function getQtyFromForm(form) {
    let el = form.querySelector('[name="quantity"]');
    if (!el && form.id) {
      const safeFormId = String(form.id).replace(/"/g, '\\"');
      el = document.querySelector(`[form="${safeFormId}"][name="quantity"]`);
    }
    return getInt(el?.value, 1);
  }

  function findAddonForForm(form) {
    const inForm = form.querySelector(".dev-card-addon");
    if (inForm) return inForm;

    const sectionRoot = form.closest('[id^="shopify-section-"]');
    if (sectionRoot) {
      const inSection = sectionRoot.querySelector(".dev-card-addon");
      if (inSection) return inSection;
    }

    const aroundProductInfo = form.closest(".hdt-main-product-wrap, .hdt-group-product-block, .hdt-s-inner");
    if (aroundProductInfo) {
      const nearby = aroundProductInfo.querySelector(".dev-card-addon");
      if (nearby) return nearby;
    }

    return null;
  }

  function getFormFromEventTarget(target) {
    if (target instanceof HTMLFormElement) return target;
    if (target instanceof Element) {
      return target.querySelector('form[action*="/cart/add"]') || target.closest('form[action*="/cart/add"]');
    }
    return null;
  }

  function getSectionIdFromCartData(cartData) {
    const sections = cartData && cartData.sections;
    if (!sections || typeof sections !== "object") return "";
    const ids = Object.keys(sections).filter(Boolean);
    return ids[0] || "";
  }

  async function addCardLineItem(pending, sectionId) {
    const fd = new FormData();
    fd.append("id", String(pending.cardVariantId));
    fd.append("quantity", String(Math.max(1, pending.qty || 1)));
    if (sectionId) fd.append("sections", sectionId);
    for (const [k, v] of Object.entries(pending.cardProps || {})) {
      if (v !== "" && v != null) fd.append(`properties[${k}]`, String(v));
    }

    const res = await fetch(rootPath + "cart/add.js", {
      method: "POST",
      headers: { Accept: "text/html" },
      credentials: "same-origin",
      body: fd,
    });
    const data = await res.json();
    if (!res.ok || data?.status) {
      throw new Error(data?.description || data?.message || "Грешка при добавяне на картичката.");
    }
    return data;
  }

  const pendingByForm = new WeakMap();

  document.addEventListener("DOMContentLoaded", () => {
    initDynamicUi(document);
  });

  if (document.readyState !== "loading") {
    initDynamicUi(document);
  }

  const dynamicUiObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (
          node.matches(".dev-card-addon") ||
          node.matches('[id^="hdt-cart-card-rescue-"]') ||
          node.querySelector(".dev-card-addon") ||
          node.querySelector('[id^="hdt-cart-card-rescue-"]')
        ) {
          initDynamicUi(node);
        }
      });
    }
  });

  if (document.documentElement) {
    dynamicUiObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Записваме избора при submit, без да спираме native потока на темата.
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes("/cart/add")) return;

      const addonEl = findAddonForForm(form);
      if (!addonEl) {
        pendingByForm.delete(form);
        return;
      }

      initAddon(addonEl);

      const cardVariantId = getSelectedCardVariantId(addonEl);
      if (!cardVariantId) {
        pendingByForm.delete(form);
        return;
      }
      setError(addonEl, "");

      const qty = getQtyFromForm(form);

      const message = (addonEl.querySelector(".dev-card-addon__textarea")?.value || "").trim();
      const parentTitle = addonEl.dataset.parentTitle || "";
      const parentHandle = addonEl.dataset.parentHandle || "";

      const cardProps = {};
      if (parentTitle) cardProps["Към букет"] = parentTitle;
      if (parentHandle) cardProps["_parent_handle"] = parentHandle;
      if (message) cardProps["Послание"] = message;

      pendingByForm.set(form, {
        cardVariantId,
        qty,
        cardProps,
      });
    },
    true
  );

  // След успешен add на основния продукт от theme core, добавяме картичката отделно.
  document.addEventListener("cart:update", async (e) => {
    const detail = e && e.detail ? e.detail : {};
    if (detail.source !== "product-form-component") return;

    const form = getFormFromEventTarget(e.target);
    if (!form) return;

    const pending = pendingByForm.get(form);
    if (!pending || pending.processing) return;
    pending.processing = true;
    pendingByForm.set(form, pending);

    const addonEl = findAddonForForm(form);
    try {
      const sectionId = getSectionIdFromCartData(detail.cartData);
      const data = await addCardLineItem(pending, sectionId);

      if (data && data.sections) {
        document.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: { cartData: data, source: "dev-card-addon", actionAfterATC: "no_action" },
          })
        );
      } else {
        document.dispatchEvent(new CustomEvent("cart:reload", { bubbles: true }));
      }
    } catch (err) {
      if (addonEl) setError(addonEl, err?.message || "Възникна грешка при добавяне на картичката.");
      document.dispatchEvent(new CustomEvent("cart:reload", { bubbles: true }));
    } finally {
      pendingByForm.delete(form);
    }
  });
})();
